import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6919254c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Basic information"),
  /*#__PURE__*/_createElementVNode("p", null, "Be descriptive and name your event.")
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Date and time"),
  /*#__PURE__*/_createElementVNode("p", null, "Set when your event starts and ends.")
], -1))
const _hoisted_3 = {
  key: 1,
  class: "colored-bg full-height"
}
const _hoisted_4 = { class: "container" }
const _hoisted_5 = { class: "flex-desktop" }
const _hoisted_6 = { class: "full-width" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Basic information", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Be descriptive and name your event.", -1))
const _hoisted_9 = { class: "full-width" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Date and time", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Set when your event starts and ends.", -1))
const _hoisted_12 = { style: {"width":"300px","margin":"50px auto 30px auto"} }
const _hoisted_13 = { class: "container" }

import { save } from "ionicons/icons";
import { reactive } from "vue";
import {
  IonInput,
  IonPage,
  IonButton,
  IonNote,
  IonLoading,
  IonFooter,
  IonContent,
  IonList,
  IonItem,
  IonBackButton,
  IonHeader,
  IonToolbar,
  IonLabel,
  IonIcon,
  IonTitle,
  IonButtons,
  useIonRouter,
  onIonViewWillEnter,
} from "@ionic/vue";
import { useWindowWidth } from "@/composition/window";
import { useForm } from "../..";
import { addEvent } from "@/api/events";
import { useContextStore } from "@/stores/context";
import { useToasters } from "@/composition/toasters";
import { useUserStore } from "@/stores/user";
import { watch } from "vue";
import { event as gtag_event } from "vue-gtag";


export default /*#__PURE__*/_defineComponent({
  __name: 'NewEvent',
  setup(__props) {

const { isMobile } = useWindowWidth();
const state = reactive({
  start_date_open: false,
  end_date_open: false,
  loading: false,
  errors: {
    name: [],
    slug: [],
    capacity: [],
    start_date: [],
    end_date: [],
    timezone: [],
  },
});

const form = useForm();
const router = useIonRouter();
const contextStore = useContextStore();
const userStore = useUserStore();
const toasters = useToasters();

// const emptyFieldsPresent = computed(
//   () =>
//     form.event.name === "" ||
//     form.event.start_date === "" ||
//     form.event.end_date === "" ||
//     form.event.capacity === 0 ||
//     form.event.timezone_id === ""
// );

onIonViewWillEnter(() => {
  gtag_event("event_form_page_access", {
    category: "check-in app",
    label: "Event form page access",
  });
});

const createEvent = () => {
  state.loading = true;
  state.errors = {
    name: [],
    slug: [],
    capacity: [],
    start_date: [],
    end_date: [],
    timezone: [],
  };

  form.event.client_account = userStore.related.clients[0].id;

  addEvent(form.event)
    .then((response) => {
      const event = response.data;

      gtag_event("event_created", {
        category: "check-in app",
        label: "New event created",
      });

      contextStore.getEvent(event.id).then(() => {
        state.loading = false;
        userStore.fetchRoles();
        router.push(`/event/${contextStore.event.id}/home`);
      });
    })
    .catch((err) => {
      if (Array.isArray(err.response.data)) {
        toasters.addError(err.response.data[0]);

        const limits_achieved_msg =
          "Maximum capacity or maximum number of events exceeded.";

        if (err.response.data[0] === limits_achieved_msg) {
          gtag_event("limits_achieved", {
            category: "check-in app",
            label: "Limits achieved while trying to create a event",
          });
        }
      } else {
        state.errors = { ...state.errors, ...err.response.data };
      }
      state.loading = false;
    });
};

watch(
  () => form.event.start_date,
  (start_date) => {
    if (start_date) {
      let date_obj = new Date(start_date);
      date_obj.setDate(date_obj.getDate() + 1);
      form.event.end_date = date_obj.toISOString().slice(0, -8);
    }
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonButtons), { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonBackButton), {
                    color: "white",
                    "default-href": _unref(userStore).userIsLoggedIn ? '/home' : '/onboarding'
                  }, null, 8, ["default-href"])
                ]),
                _: 1
              }),
              _createVNode(_unref(IonTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode("New event")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_unref(isMobile))
        ? (_openBlock(), _createBlock(_unref(IonContent), { key: 0 }, {
            default: _withCtx(() => [
              _hoisted_1,
              _createVNode(_unref(IonList), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonItem), {
                    class: _normalizeClass({
          'ion-invalid':
            state.errors.name.length > 0 || state.errors.slug.length > 0,
        })
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonLabel), { position: "stacked" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Name")
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonInput), {
                        modelValue: _unref(form).event.name,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).event.name) = $event)),
                        placeholder: "My event"
                      }, null, 8, ["modelValue"]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.errors.name, (message, i) => {
                        return (_openBlock(), _createBlock(_unref(IonNote), {
                          slot: "error",
                          key: `name-error-${i}`
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(message), 1)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128)),
                      (state.errors.slug.length > 0)
                        ? (_openBlock(), _createBlock(_unref(IonNote), {
                            key: 0,
                            slot: "error"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" This name is already in use. Please try another one. ")
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["class"]),
                  _createVNode(_unref(IonItem), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonLabel), { position: "stacked" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Location")
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonInput), {
                        modelValue: _unref(form).event.location,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).event.location) = $event)),
                        placeholder: "New York"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonItem), {
                    class: _normalizeClass({ 'ion-invalid': state.errors.capacity.length > 0 })
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonLabel), { position: "stacked" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Capacity")
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonInput), {
                        modelValue: _unref(form).event.capacity,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).event.capacity) = $event)),
                        type: "number",
                        placeholder: "1000"
                      }, null, 8, ["modelValue"]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.errors.capacity, (message, i) => {
                        return (_openBlock(), _createBlock(_unref(IonNote), {
                          slot: "error",
                          key: `capacity-error-${i}`
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(message), 1)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["class"])
                ]),
                _: 1
              }),
              _hoisted_2,
              _createVNode(_unref(IonList), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonItem), {
                    class: _normalizeClass({ 'ion-invalid': state.errors.start_date.length > 0 })
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonLabel), { position: "stacked" }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Start date ")
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonInput), {
                        type: "datetime-local",
                        modelValue: _unref(form).event.start_date,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(form).event.start_date) = $event))
                      }, null, 8, ["modelValue"]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.errors.start_date, (message, i) => {
                        return (_openBlock(), _createBlock(_unref(IonNote), {
                          slot: "error",
                          key: `start_date-error-${i}`
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(message), 1)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["class"]),
                  _createVNode(_unref(IonItem), {
                    class: _normalizeClass({ 'ion-invalid': state.errors.end_date.length > 0 })
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonLabel), { position: "stacked" }, {
                        default: _withCtx(() => [
                          _createTextVNode("End date")
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonInput), {
                        type: "datetime-local",
                        modelValue: _unref(form).event.end_date,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(form).event.end_date) = $event))
                      }, null, 8, ["modelValue"]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.errors.end_date, (message, i) => {
                        return (_openBlock(), _createBlock(_unref(IonNote), {
                          slot: "error",
                          key: `end_date-error-${i}`
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(message), 1)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["class"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _hoisted_8,
                  _createVNode(_unref(IonList), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonItem), {
                        class: _normalizeClass({
                'ion-invalid':
                  state.errors.name.length > 0 ||
                  state.errors.slug.length > 0,
              })
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonLabel), { position: "stacked" }, {
                            default: _withCtx(() => [
                              _createTextVNode("Name")
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(IonInput), {
                            modelValue: _unref(form).event.name,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(form).event.name) = $event)),
                            placeholder: "My event"
                          }, null, 8, ["modelValue"]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.errors.name, (message, i) => {
                            return (_openBlock(), _createBlock(_unref(IonNote), {
                              slot: "error",
                              key: `name-error-${i}`
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(message), 1)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128)),
                          (state.errors.slug.length > 0)
                            ? (_openBlock(), _createBlock(_unref(IonNote), {
                                key: 0,
                                slot: "error"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" This name is already in use. Please try another one. ")
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["class"]),
                      _createVNode(_unref(IonItem), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonLabel), { position: "stacked" }, {
                            default: _withCtx(() => [
                              _createTextVNode("Location")
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(IonInput), {
                            modelValue: _unref(form).event.location,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(form).event.location) = $event)),
                            placeholder: "New York"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonItem), {
                        class: _normalizeClass({ 'ion-invalid': state.errors.capacity.length > 0 })
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonLabel), { position: "stacked" }, {
                            default: _withCtx(() => [
                              _createTextVNode("Capacity")
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(IonInput), {
                            modelValue: _unref(form).event.capacity,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(form).event.capacity) = $event)),
                            type: "number",
                            placeholder: "1000"
                          }, null, 8, ["modelValue"]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.errors.capacity, (message, i) => {
                            return (_openBlock(), _createBlock(_unref(IonNote), {
                              slot: "error",
                              key: `capacity-error-${i}`
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(message), 1)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["class"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _hoisted_11,
                  _createVNode(_unref(IonList), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonItem), {
                        class: _normalizeClass({ 'ion-invalid': state.errors.start_date.length > 0 })
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonLabel), { position: "stacked" }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Start date ")
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(IonInput), {
                            type: "datetime-local",
                            modelValue: _unref(form).event.start_date,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(form).event.start_date) = $event))
                          }, null, 8, ["modelValue"]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.errors.start_date, (message, i) => {
                            return (_openBlock(), _createBlock(_unref(IonNote), {
                              slot: "error",
                              key: `start_date-error-${i}`
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(message), 1)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["class"]),
                      _createVNode(_unref(IonItem), {
                        class: _normalizeClass({ 'ion-invalid': state.errors.end_date.length > 0 })
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonLabel), { position: "stacked" }, {
                            default: _withCtx(() => [
                              _createTextVNode("End date")
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(IonInput), {
                            type: "datetime-local",
                            modelValue: _unref(form).event.end_date,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(form).event.end_date) = $event))
                          }, null, 8, ["modelValue"]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.errors.end_date, (message, i) => {
                            return (_openBlock(), _createBlock(_unref(IonNote), {
                              slot: "error",
                              key: `end_date-error-${i}`
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(message), 1)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["class"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_unref(IonButton), {
                  expand: "block",
                  color: "primary",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (createEvent()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonIcon), {
                      slot: "start",
                      icon: _unref(save)
                    }, null, 8, ["icon"]),
                    _createTextVNode(" Save ")
                  ]),
                  _: 1
                })
              ])
            ])
          ])),
      (_unref(isMobile))
        ? (_openBlock(), _createBlock(_unref(IonFooter), { key: 2 }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("section", null, [
                  _createVNode(_unref(IonButton), {
                    expand: "block",
                    color: "primary",
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (createEvent()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonIcon), {
                        slot: "start",
                        icon: _unref(save)
                      }, null, 8, ["icon"]),
                      _createTextVNode(" Save ")
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_unref(IonLoading), {
        "is-open": state.loading,
        message: "Please wait..."
      }, null, 8, ["is-open"])
    ]),
    _: 1
  }))
}
}

})